import { Provider } from "react-redux";
import { store } from "./store";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes";
import AnalyticsBootstrap from "./components/AnalyticsBootstrap/AnalyticsBootstrap";
import CookieBanner from "./components/CookieBanner/CookieBanner";

function App() {
  return (
    <Provider store={store}>
      <AnalyticsBootstrap />
      <RouterProvider router={router} />
      <CookieBanner />
    </Provider>
  );
}

export default App;
